// Import axios
import axios from 'axios'
axios.defaults.withCredentials = true
// import Bus from '@/assets/js/vueBus'

axios.interceptors.request.use(
  config => {
    // adapter: ƒ xhrAdapter(config)
    // data: "{"email":"111","pwd":"FB131BC57A477C8C9D068F1EE5622AC304195A77164CCC2D75D82DFE1A727BA8D674ED87F96143B2B416AACEFB555E3045C356FAA23E6D21DE72B85822E39FDD","imgCode":"111","key":"***LITERAL_REMOVED***"}"
    // headers: {Accept: "application/json, text/plain, */*", Content-Type: "application/json;charset=utf-8"}
    // maxContentLength: -1
    // method: "post"
    // timeout: 0
    // transformRequest: [ƒ]
    // transformResponse: [ƒ]
    // url: "/userGroup/user-group/login/signIn"
    // validateStatus: ƒ validateStatus(status)
    // xsrfCookieName: "XSRF-TOKEN"
    // xsrfHeaderName: "X-XSRF-TOKEN"

    //     if(config.method  === 'post' && config.data.constructor !== FormData && config.headers['Content-Type'] != "application/json;charset=UTF-8"  && !config.contentType){
    //         config.data = Qs.stringify(config.data);
    //         config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    //     }
    // config.headers.Authorization = session||Tool.sgStorage("session");
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

axios.interceptors.response.use(
  response => {
    //   config: {url: "/userGroup/user-group/login/getVCode", method: "get", headers: {…}, transformRequest: Array(1), transformResponse: Array(1), …}
    // data: {errorCode: "0x0", errorInfo: "Success", result: {…}}
    // headers: {connection: "close", content-type: "application/json;charset=UTF-8", date: "Mon, 27 Apr 2020 07:10:41 GMT", server: "nginx/1.14.2", transfer-encoding: "chunked", …}
    // request: XMLHttpRequest {readyState: 4, timeout: 0, withCredentials: false, upload: XMLHttpRequestUpload, onreadystatechange: ƒ, …}
    // status: 200
    // statusText: "OK"
    // if(response.data.errorCode === '81000001') {
    //     Bus.$emit("jumpLoginPage");
    // }
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 402:
        case 401:
          // window.location.href = "login.jsp";
          // Bus.$emit("jumpLoginPage");
          break
      }
    }
    return Promise.reject(error.response)
  }
)

// export APIService
export default { axios }
